<template>
	<Dialog
		:dialogVisible="dialog"
		title="Create a New Project"
		:agreeText="creating ? 'Creating' : 'Create'"
		:cancelText="'Back'"
		:disableAgreeButton="createButtonDisabled"
		@cancel="cancel"
		@agree="agree">
		<template v-slot:dialog-body>
			<v-form ref="formRef" v-model="isFormValid">
				<v-text-field
					id="project-name"
					counter="255"
					outlined
					label="Name (Required)"
					v-model="project.name"
					:rules="nameRules"
					v-test="'create-new-project-name'"
					validate-on-blur />
			</v-form>
		</template>
	</Dialog>
</template>

<script>
	import api from "../api";
	import Dialog from "./Dialog.vue";
	import { calculateTimeout, getMessageFromError } from "@/helpers/utilities";
	import * as Sentry from "@sentry/vue";

	export default {
		components: {
			Dialog,
		},
		data() {
			return {
				dialog: false,
				resolve: null,
				reject: null,
				formRef: false,
				project: {},
				creating: false,
				nameRules: [
					(v) => (v || "").trim().length > 0 || "Name is required.",
					(v) => (v || "").trim().length <= 255 || "Name must be less than 255 characters.",
				],
				isFormValid: false,
			};
		},
		async mounted() {},
		computed: {
			createButtonDisabled() {
				return this.creating;
			},
		},
		expose: ["open"],
		methods: {
			open(defaultName) {
				this.resetForm();
				this.project.name = defaultName ?? "";
				this.dialog = true;
				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},
			resetForm() {
				this.$refs.formRef?.reset();
			},
			async agree() {
				try {
					const isValidated = this.$refs.formRef.validate();
					if (!isValidated) {
						return;
					}
					this.creating = true;
					const record = await api.createProject(this.project);
					this.resolve(record);
					this.$toast.success("Project created successfully.");
					this.resetForm();
					this.dialog = false;
				} catch (e) {
					const message = getMessageFromError(e) || "An error occurred while creating the project.";
					this.$toast.error(message, {
						timeout: calculateTimeout(message),
					});
					Sentry.captureException(e, {
						tags: {
							method: "agree",
							file: "CreateProjectDialog",
						},
					});
				} finally {
					this.creating = false;
				}
			},
			cancel() {
				this.resetForm();
				this.dialog = false;
				this.resolve(null);
			},
		},
	};
</script>
